import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import * as providerAuthentications from '../../../redux/profiles/patientHealthboard/provider-authentications';
import * as connectedDevices from '../../../redux/profiles/patientHealthboard/connected-devices';
import * as removeAccount from '../../../redux/profiles/patientHealthboard/remove-account';
import { redirectToAddAccount } from '../../../utils/appointments/redirect-utils';
import {
  selectConnectedDevices,
  selectConnectedDevicesError,
  selectProviderAuthentications,
} from '../../../redux/profiles/patientHealthboard/selectors';
import { PROFILE } from '../../../constants/strings';
import { MAX_ADDED_ACCOUNT } from '../../PatientHealthboard/constants';
import ActionConfirmation from '../../common/ActionConfirmation';
import Button from '../../Button';
import { AppleHealth } from './AppleHealth';
import { Account } from './Account';
import { enhance } from './enhance';
import styles from './index.styl';

const DeviceSetup = ({ intl }) => {
  const { formatMessage } = intl;
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
  const [currentAccount, setCurrentAccount] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(providerAuthentications.actions.send());
    dispatch(connectedDevices.actions.send());
  }, []);

  const handleAddAccount = () => {
    redirectToAddAccount();
  };

  const listOfAddedAccount = useSelector(selectProviderAuthentications);
  const listOfAddedDevices = useSelector(selectConnectedDevices);
  const noPermissionToAccount = useSelector(selectConnectedDevicesError);

  return (
    <section className={styles.root}>
      <h3 className={styles.sectionTitle}>
        {formatMessage({ ...PROFILE.deviceSetup.title })}
      </h3>
      <AppleHealth />
      {listOfAddedAccount.length === 0 && (
        <div className={styles.noAccount}>
          {formatMessage({ ...PROFILE.deviceSetup.noAccount })}
          <span className={styles.noAccountDescription}>
            {formatMessage({ ...PROFILE.deviceSetup.addAccountDescription })}
          </span>
        </div>
      )}
      {listOfAddedAccount.length !== 0 &&
        listOfAddedAccount.map(account => (
          <Account
            setCurrentAccount={setCurrentAccount}
            setShowRemoveConfirmation={setShowRemoveConfirmation}
            account={account}
            key={account.id}
            connectedDevices={listOfAddedDevices}
            noPermissionToAccount={noPermissionToAccount}
          />
        ))}
      {listOfAddedAccount.length !== MAX_ADDED_ACCOUNT && (
        <Button
          color="accent"
          type="button"
          onClick={handleAddAccount}
          className={styles.addDeviceBtn}
        >
          {formatMessage({ ...PROFILE.deviceSetup.addDeviceAccount })}
        </Button>
      )}
      {showRemoveConfirmation && (
        <ActionConfirmation
          intl={intl}
          onSubmit={() =>
            dispatch(removeAccount.actions.send({ id: currentAccount }))
          }
          onClose={() => setShowRemoveConfirmation(false)}
          opened={showRemoveConfirmation}
          withHeading={false}
          actionButtonText={formatMessage({
            id: 'common.remove',
          })}
          content={
            <div className={styles.removeConfirmationTitle}>
              {formatMessage({
                id: 'profile.section.deviceSetup.removeConfirmation',
              })}
            </div>
          }
        />
      )}
    </section>
  );
};

DeviceSetup.propTypes = {
  intl: PropTypes.object,
};

export default enhance(DeviceSetup);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeviceSetup/index.jsx